import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { SendPaymentTypeEnum } from '@nttp/enum/send-payment-type.enum';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SendPaymentInstructionService } from '@pg-app/client/send-payment-instruction/services/send-payment-instruction.service';
import { SendPaymentInstructionModelService } from '@pg-app/client/send-payment-instruction/services/send-payment-instruction.model.service';
import { MatDialog } from '@angular/material/dialog';
import { RegistrationStep2Service } from '@pg-app/client/services/registrationStep2.service';
import { Observable } from 'rxjs';
import { startWith, debounceTime, map } from 'rxjs/operators';
import { Regex } from '@pg-app/shared/constants/regex';

@Component({
  selector: 'np-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.scss']
})
export class PaymentConfirmationComponent implements OnInit {
  paymentConfirmationForm: FormGroup;
  bankAccount = null;
  paymentCodes = [];
  filteredOptions: Observable<Array<any>>;
  paymentCodeExist = true;
  paymentCodeIdSelected = null;
  @Input()
  sendPaymentType = SendPaymentTypeEnum.SendPaymentDashboard;

  constructor(
    private formBuilder: FormBuilder,
    private sendPaymentInstructionService: SendPaymentInstructionService,
    private toasterService: ToastrService,
    private dialog: MatDialog,
    public paymentModel: SendPaymentInstructionModelService,
    public registerService: RegistrationStep2Service,
    private el: ElementRef
  ) {}

  ngOnInit(): void {
    this.paymentConfirmationForm = this.formBuilder.group({
      paymentReference: ['', [Validators.required, Validators.maxLength(70), Validators.pattern(Regex.nonSwiftCharacters)]],
      externalPaymentId: ['', [Validators.maxLength(20), Validators.pattern(Regex.nonSwiftCharacters)]]
    });
    this.getBankPayment();
    this.getPaymentCode();
  }

  getBankPayment() {
    const param = {
      id: this.paymentModel.selectedRecipient.id,
      clientId: null
    };
    this.sendPaymentInstructionService.getPaymentBankName(param).subscribe(data => {
      this.bankAccount = data;
      if (data && data.reference) {
        this.paymentConfirmationForm.get('paymentReference').setValue(data.reference);
      }
      const paymentReference = this.el.nativeElement.querySelector(`[formcontrolname="paymentReference"]`);
      paymentReference.focus();
    });
  }

  public goBack() {
    this.dialog.closeAll();
    this.paymentModel.clearData();
    if (this.sendPaymentType === SendPaymentTypeEnum.SendPaymentFromTrade) {
      window.location.reload();
    }
  }

  private getPaymentCode() {
    if  (this.paymentModel.currency.code == "CNY") {
      this.sendPaymentInstructionService.getPaymentCodesForCNY()
      .subscribe(res => {
        this.updatePurposeOfPayments(res);
      });
    } else {
      this.sendPaymentInstructionService
        .getPaymentCodes(this.paymentModel.selectedRecipient.bank.countryId)
        .subscribe(res => {
          this.updatePurposeOfPayments(res);
        });
    }
  }

  private updatePurposeOfPayments(res: any) {
    if (res.length > 0) {
      this.paymentCodes = res;
      this.paymentConfirmationForm.addControl('paymentCode', new FormControl('', [Validators.required]));
      this.filteredOptions = this.paymentConfirmationForm.get('paymentCode').valueChanges.pipe(
        startWith(''),
        debounceTime(450),
        map(value => this.filterSearch(value))
      );

      // Pre-select the purpose of payment.... if there's one specified in the bank's country
      const popId = this.paymentModel.selectedRecipient.bank.purposeOfPaymentId;
      const popExists = this.paymentCodes.find(item => item.id.toLowerCase() === popId.toLowerCase());
      if (!popExists) {
        this.paymentCodeExist = false;
        this.paymentCodeIdSelected = null;
        return;
      }
      this.paymentCodeExist = true;
      this.paymentCodeIdSelected = popExists.id;
      this.paymentConfirmationForm.get('paymentCode').setValue(popExists.code);
    }
  }

  private filterSearch(value: any): any[] {
    const filterValue = !value ? '' : value.toLowerCase();
    return this.paymentCodes.filter(option => {
      return option.code.toLowerCase().indexOf(filterValue) !== -1;
    });
  }

  payNow() {
    this.paymentConfirmationForm.markAllAsTouched();
    if (!this.paymentConfirmationForm.valid) {
      return;
    }

    if (this.paymentCodes.length > 0) {
      const paymentCode = this.paymentConfirmationForm.get('paymentCode').value;
      const paymentCodeFound = this.paymentCodes.find(item => item.code.toLowerCase() === paymentCode.toLowerCase());
      if (!paymentCodeFound) {
        this.paymentCodeIdSelected = null;
        this.paymentCodeExist = false;
        this.toasterService.error('Purpose of payment not found');
        return;
      }
      this.paymentCodeIdSelected = paymentCodeFound.id;
      this.paymentCodeExist = true;
    }

    this.paymentModel.paymentReference = this.paymentConfirmationForm.get('paymentReference').value;
    this.paymentModel.externalPaymentId = this.paymentConfirmationForm.get('externalPaymentId').value;
    this.paymentModel.purposePaymentIdSelected = this.paymentCodeIdSelected;
    this.paymentModel.step = this.paymentModel.sendPaymentStep.validatePayment;
  }
}
